import {createContext} from 'react'

const OrdenesCompraContext = createContext()

export default OrdenesCompraContext